export function isTargetElementUnderContainer(containerRef: React.RefObject<HTMLElement>, targetNode: Node) {
    const { current } = containerRef;
    return current !== null && current.contains(targetNode);
}
